export default __webpack_public_path__ + "static/media/auditProcessingIcon.aa4c1307.svg";